export default __webpack_public_path__ + "static/media/gameplayBg.78c1c5a0.png";